import React from 'react';
import { Clock, Ban, CloudOff, LogOut } from 'lucide-react';
import { FOCUS_RING } from './format';
import iconWhite from '../../assets/images/icon_white.png';

export type PortalState = 'awaiting' | 'ended' | 'unavailable';

const CONTENT: Record<PortalState, { title: string; body: string; Icon: typeof Clock }> = {
  awaiting: {
    title: 'Awaiting approval',
    body: 'Your account is set up. The agency needs to approve your access before you can see the patient’s information. You can sign in again later.',
    Icon: Clock,
  },
  ended: {
    title: 'Access ended',
    body: 'Your access to the family portal has ended. If you think this is a mistake, contact the agency.',
    Icon: Ban,
  },
  unavailable: {
    title: 'Portal unavailable',
    body: 'The family portal is not available right now. Contact the agency for help.',
    Icon: CloudOff,
  },
};

interface PortalStateScreenProps {
  state: PortalState;
  onSignOut: () => void;
}

/** Awaiting approval / Access ended / Portal unavailable. Contains no PHI. */
const PortalStateScreen: React.FC<PortalStateScreenProps> = ({ state, onSignOut }) => {
  const { title, body, Icon } = CONTENT[state];
  return (
    <main className="flex min-h-screen items-center justify-center bg-slate-50 px-4 py-10">
      <section className="w-full max-w-md overflow-hidden rounded-2xl border border-slate-200 bg-white text-center shadow-sm" aria-labelledby="portal-state-title">
        <div className="flex items-center justify-center gap-2 bg-slate-900 py-4 text-white">
          <img src={iconWhite} alt="" className="h-7 w-7" />
          <p className="text-xl font-semibold">Pelora Health</p>
        </div>
        <div className="p-8">
        <Icon size={40} className="mx-auto mb-4 text-teal-700" aria-hidden="true" />
        <h1 id="portal-state-title" className="text-xl font-semibold text-slate-900">
          {title}
        </h1>
        <p className="mt-3 text-base leading-6 text-slate-700">{body}</p>
        <button
          type="button"
          onClick={onSignOut}
          className={`mt-6 inline-flex min-h-11 items-center justify-center gap-2 rounded-md bg-slate-800 px-5 py-2 text-sm font-medium text-white hover:bg-slate-700 ${FOCUS_RING}`}
        >
          <LogOut size={16} aria-hidden="true" />
          Sign out
        </button>
        </div>
      </section>
    </main>
  );
};

export default PortalStateScreen;
